import React, { useEffect } from "react";
import { useFormik } from "formik";

import "./SelectColumnContent.styles.scss";
import { Select, SelectDateRange } from "components/forms";
import { useReportsMetaSelector } from "store";
import { DateRangeValue, ReportsQueries } from "store/types";
import TodayOutlinedIcon from "@mui/icons-material/TodayOutlined";

export type DataFormation = Partial<Pick<ReportsQueries, "comparisonColumns" | "dateRange" | "secondaryDateRange">>;

interface SelectColumnContentProps {
  queriedDateRange: DateRangeValue<string>;
  queriedSecondaryDateRange: DateRangeValue<string>;
  onChangeDataFormation?: (dataFormation: DataFormation) => void;
  selectedColumns: string[];
}

export const SelectColumnContent: React.FC<SelectColumnContentProps> = ({
  onChangeDataFormation,
  queriedDateRange,
  queriedSecondaryDateRange,
  selectedColumns
}) => {
  const { comparisonColumns } = useReportsMetaSelector();

  const initialValues = {
    dateRange: queriedDateRange,
    secondaryDateRange: queriedSecondaryDateRange,
    column1: selectedColumns[0] || "",
    column2: selectedColumns[1] || ""
  };

  const { setFieldValue, values } = useFormik({
    initialValues,
    onSubmit: (values) => console.log(values),
    enableReinitialize: true
  });

  useEffect(() => {
    if (onChangeDataFormation) {
      onChangeDataFormation({
        comparisonColumns: [values.column1, values.column2],
        dateRange: values.dateRange,
        secondaryDateRange: values.secondaryDateRange
      });
    }
  }, [values]);

  return (
    <div className="select-column-content">
      <div className="row">
        <div className="col label">Set periods</div>
        <div className="col">
          <SelectDateRange
            formControlProps={{ sx: { minWidth: "160px" } }}
            selectProps={{
              startAdornment: <TodayOutlinedIcon sx={{ fontSize: "15px" }} />
            }}
            value={values.dateRange}
            onChange={(date) => setFieldValue("dateRange", date)}
          />
        </div>
        <div className="col">
          <SelectDateRange
            formControlProps={{ sx: { minWidth: "160px" } }}
            selectProps={{
              startAdornment: <TodayOutlinedIcon sx={{ fontSize: "15px" }} />
            }}
            value={values.secondaryDateRange}
            onChange={(date) => setFieldValue("secondaryDateRange", date)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col label">Columns</div>
        <div className="col">
          <Select
            label=""
            formProps={{ sx: { minWidth: "120px" } }}
            variant="outlined"
            items={comparisonColumns}
            value={values.column1}
            onChange={(e) => setFieldValue("column1", e.target.value)}
          />
        </div>
        <div className="col">
          <Select
            label=""
            variant="outlined"
            items={comparisonColumns}
            formProps={{ sx: { minWidth: "120px" } }}
            value={values.column2}
            onChange={(e) => setFieldValue("column2", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};
